module.exports.brands = [
    "#00cec9",
    "#0984e3",
    "#3c6382",
    "#ff7675"
]